/* eslint-disable import/prefer-default-export */
export const DRAWER_WIDTH = 200;

export const LOADING_SPINNER_SIZE_SMALL = 20;
export const LOADING_SPINNER_SIZE_MEDIUM = 40;
export const LOADING_SPINNER_SIZE_LARGE = 60;

export const ALERT_OPEN_DURATION = 5000;

export const IMAGE_AREA_WIDTH_9_16 = 240;
export const IMAGE_AREA_HEIGHT_9_16 = 426.03;

export const IMAGE_AREA_WIDTH_2_3 = 200;
export const IMAGE_AREA_HEIGHT_2_3 = 300;

export const AUDIO_AREA_WIDTH = 200;
export const AUDIO_AREA_HEIGHT = 70;

export const INPUT_WIDTH = 200;
export const INPUT_HEIGHT = 40;
